import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HttpResponse, HttpErrorResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {FieldActivity, IFieldActivity} from '../../shared/model/field-activity.model';
import {FieldActivityService} from './field-activity.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Organization} from "../../shared/model/organization.model";

@Component({
  selector: 'app-field-activity-update',
  templateUrl: './field-activity-update.component.html'
})
export class FieldActivityUpdateComponent implements OnInit {
  fieldActivity: IFieldActivity = new FieldActivity();
  isSaving: boolean;
  @Input() fieldActivityEdit;
  @Input() customerId;

  constructor(protected fieldActivityService: FieldActivityService, protected activatedRoute: ActivatedRoute, public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
    this.isSaving = false;
// alert(' in init ==' + this.fieldActivityEdit);
    if (this.fieldActivityEdit) {
      this.fieldActivityService.find(this.fieldActivityEdit).subscribe(
        (res: HttpResponse<IFieldActivity>) => {
          this.fieldActivity = res.body;
          // alert(this.fieldActivity);
        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    }

    // this.activatedRoute.data.subscribe(({fieldActivity}) => {
    //   this.fieldActivity = fieldActivity;
    // });
  }


  protected onError(errorMessage: string) {
    // this.jhiAlertService.error(errorMessage, null, null);
  }

  previousState() {
    window.history.back();
  }

  save() {
    this.isSaving = true;
    // this.fieldActivity.organization = new Organization(1);

    if (this.fieldActivity.id !== undefined) {
      this.subscribeToSaveResponse(this.fieldActivityService.update(this.fieldActivity));
    } else {

      this.subscribeToSaveResponse(this.fieldActivityService.create(this.fieldActivity));
    }
  }

  protected subscribeToSaveResponse(result: Observable<HttpResponse<IFieldActivity>>) {
    result.subscribe((res: HttpResponse<IFieldActivity>) => this.onSaveSuccess(), (res: HttpErrorResponse) => this.onSaveError());
  }

  protected onSaveSuccess() {
    this.isSaving = false;
    this.activeModal.dismiss('cancel');

    // this.previousState();
  }

  protected onSaveError() {
    this.isSaving = false;
  }


  clear() {
    this.activeModal.dismiss('cancel');
  }


}
